// extracted by mini-css-extract-plugin
export default {"form":"CreateFolderModalTemplate_form__kqFvG","button":"CreateFolderModalTemplate_button__OOepy","formActions":"CreateFolderModalTemplate_formActions__8puFr"};